// RajoutMelangeResineAmorceur.jsx
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../api";
import { Scanner } from "@yudiel/react-qr-scanner";
import { DEFAULT_PRELEVEMENT_ENTITE, PRELEVEMENT_ENTITES } from "./prelevementEntites";

import { useI18n } from "../i18n/I18nContext";

function normalize(text) {
  return text.toString().toLowerCase().normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, " ").trim();
}
function toFloat(v) {
  if (!v && v !== 0) return 0;
  return Number(v.toString().replace(",", ".")) || 0;
}
function isAndroid() { return /Android/i.test(navigator.userAgent || ""); }

export default function RajoutMelangeResineAmorceur() {
  const { t, ui } = useI18n();

  const navigate = useNavigate();

  const [operator, setOperator]                       = useState("");
  const [entite, setEntite]                           = useState(DEFAULT_PRELEVEMENT_ENTITE);
  const [parcMelangeEnCours, setParcMelangeEnCours]   = useState("");
  const [parcMelangeSearch, setParcMelangeSearch]     = useState("");
  const [melangePns, setMelangePns]                   = useState([]);
  const [showMelangeList, setShowMelangeList]         = useState(false);
  const [showParcScanner, setShowParcScanner]         = useState(false);
  const [pnResine, setPnResine]                       = useState("");
  const [pnResineSearch, setPnResineSearch]           = useState("");
  const [resinePns, setResinePns]                     = useState([]);
  const [showResineList, setShowResineList]           = useState(false);
  const [showResineScanner, setShowResineScanner]     = useState(false);
  const [pnAmorceur, setPnAmorceur]                   = useState("");
  const [pnAmorceurSearch, setPnAmorceurSearch]       = useState("");
  const [amorceurPns, setAmorceurPns]                 = useState([]);
  const [showAmorceurList, setShowAmorceurList]       = useState(false);
  const [showAmorceurScanner, setShowAmorceurScanner] = useState(false);
  const [qtyResine, setQtyResine]                     = useState("");
  const [qtyAmorceur, setQtyAmorceur]                 = useState("");
  const [qtyMelangeFinal, setQtyMelangeFinal]         = useState("");
  const [temperature, setTemperature]                 = useState("");
  const [viscosite, setViscosite]                     = useState("");
  const [extraitSec, setExtraitSec]                   = useState("");
  const [dureeRepos, setDureeRepos]                   = useState("");
  const [solutionParcNumber, setSolutionParcNumber]   = useState("");
  const [commentSolution, setCommentSolution]         = useState("");
  const [now, setNow]                                 = useState(new Date());
  const [sending, setSending]                         = useState(false);
  const [printing, setPrinting]                       = useState(false);
  const [error, setError]                             = useState("");
  const [success, setSuccess]                         = useState("");
  const melangeBoxRef  = useRef(null);
  const resineBoxRef   = useRef(null);
  const amorceurBoxRef = useRef(null);

  useEffect(() => {
    const raw = localStorage.getItem("user");
    if (raw) { try { setOperator(JSON.parse(raw).username || ""); } catch (e) { console.error(e); } }
  }, []);

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    function onOutside(e) {
      if (melangeBoxRef.current  && !melangeBoxRef.current.contains(e.target))  setShowMelangeList(false);
      if (resineBoxRef.current   && !resineBoxRef.current.contains(e.target))   setShowResineList(false);
      if (amorceurBoxRef.current && !amorceurBoxRef.current.contains(e.target)) setShowAmorceurList(false);
    }
    document.addEventListener("mousedown", onOutside);
    document.addEventListener("touchstart", onOutside);
    return () => { document.removeEventListener("mousedown", onOutside); document.removeEventListener("touchstart", onOutside); };
  }, []);

  useEffect(() => {
    apiFetch("/api/resine/list").then(async (res) => {
      if (!res.ok) return;
      const data = await res.json();
      const all  = Array.isArray(data) ? data.map((i) => i.PN || i.pn).filter(Boolean) : [];
      setResinePns(Array.from(new Set(all)));
    }).catch(console.error);
  }, []);

  useEffect(() => {
    apiFetch("/api/amorceur/list").then(async (res) => {
      if (!res.ok) return;
      const data = await res.json();
      const allPn = Array.isArray(data)
        ? data.map((item) => item.PN || item.pn).filter(Boolean)
        : [];
      setAmorceurPns(Array.from(new Set(allPn)));
    }).catch(console.error);
  }, []);

  useEffect(() => {
    apiFetch("/api/solution_amorceur/list").then(async (res) => {
      if (!res.ok) throw new Error("Erreur API");
      const data  = await res.json();
      const items = Array.isArray(data.items) ? data.items : [];
      setMelangePns(Array.from(new Set(items.map((i) => i.PN || i.pn || "").filter(Boolean))));
    }).catch((err) => console.error("Erreur chargement PN Mélange:", err));
  }, []);

  const filteredMelange  = melangePns.filter((p)  => { const s = normalize(parcMelangeSearch); return !s || normalize(p).includes(s); });
  const filteredResine   = resinePns.filter((p)   => { const s = normalize(pnResineSearch);    return !s || normalize(p).includes(s); });
  const filteredAmorceur = amorceurPns.filter((p) => { const s = normalize(pnAmorceurSearch);  return !s || normalize(p).includes(s); });

  function handleCreateParcNumber() {
    if (!parcMelangeEnCours) { alert("Merci de renseigner le Parc num Mélange en cours."); return; }
    let pnSol    = parcMelangeEnCours;
    const match  = pnSol.match(/_V(\d+)$/);
    if (match) {
      pnSol = pnSol.replace(/_V\d+$/, `_V${parseInt(match[1], 10) + 1}`).replace(/[^\p{L}\p{N}_-]+/gu, "_");
    } else {
      pnSol = `${pnSol}_V1`;
    }
    setSolutionParcNumber(pnSol);
  }

  async function clientPrintFromApi(bodyForApi) {
    const win = window.open("", "_blank");
    if (win) { win.document.write(`<!doctype html><title>Préparation…</title><body>Préparation…</body>`); win.document.close(); }
    const res = await apiFetch("/api/labels/a4", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ ...bodyForApi, format: "PNG", download: false }) });
    if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.message || `HTTP ${res.status}`); }
    const blob     = await res.blob();
    const blobUrl  = URL.createObjectURL(blob);
    const safePN   = String(bodyForApi.pn || "QR").replace(/[^\w\-]+/g, "_").slice(0, 64);
    const fileName = `A4_${bodyForApi.n || 1}x_${safePN}.png`;
    if (!win) { const a = document.createElement("a"); a.href = blobUrl; a.download = fileName; a.click(); URL.revokeObjectURL(blobUrl); return; }
    const AND = isAndroid();
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>${fileName}</title>
    <style>html,body{height:100%;margin:0}
    #bar{position:fixed;inset:auto 0 0 0;background:#111;color:#fff;padding:8px;display:flex;gap:8px;align-items:center;z-index:10}
    #bar button,#bar a{background:#E6FF3E;color:#000;border:0;padding:8px 12px;font-weight:800;cursor:pointer;text-decoration:none}
    .v{position:fixed;left:0;right:0;top:0;bottom:44px;width:100%;object-fit:contain;background:#fff}
    </style></head><body>
    <img class="v" src="${blobUrl}" alt=""/>
    <div id="bar">
      ${AND ? "" : "<button id='btnPrint'>Imprimer</button>"}
      <a href="${blobUrl}" download="${fileName}">Télécharger</a>
      <button id="btnClose">Fermer</button>
    </div>
    <script>
      ${AND ? "" : "btnPrint.onclick=()=>{try{window.focus();window.print();}catch(e){}};"}
      btnClose.onclick=()=>{try{URL.revokeObjectURL('${blobUrl}');}catch(e){};setTimeout(()=>window.close(),100);};
      window.onafterprint=()=>{try{URL.revokeObjectURL('${blobUrl}');}catch(e){};setTimeout(()=>window.close(),200);};
      ${AND ? "" : "setTimeout(()=>{try{window.focus();window.print();}catch(e){}},400);"}
    </script></body></html>`;
    win.document.open(); win.document.write(html); win.document.close();
  }

  async function handlePrintSolution() {
    if (!solutionParcNumber) { alert("Merci de créer le Parc number solution d'abord."); return; }
    try {
      setPrinting(true);
      await clientPrintFromApi({ n: 2, pn: solutionParcNumber, detail: `Rajout Résine-Amorceur ${parcMelangeEnCours || ""}`.trim(), date: new Date().toISOString().split("T")[0] });
      setSuccess("✅ Étiquette solution générée.");
    } catch (e) { setError(e.message || "Erreur impression"); }
    finally { setPrinting(false); }
  }

  function handleScanResine(results) {
    if (!results?.length) return;
    const pn = (results[0].rawValue || "").trim();
    if (!resinePns.includes(pn)) alert(`PN Résine "${pn}" non trouvé.`);
    else { setPnResine(pn); setPnResineSearch(pn); setShowResineList(false); }
    setShowResineScanner(false);
  }
  function handleScanAmorceur(results) {
    if (!results?.length) return;
    const pn = (results[0].rawValue || "").trim();
    if (!amorceurPns.includes(pn)) alert(`PN Amorceur "${pn}" non trouvé.`);
    else { setPnAmorceur(pn); setPnAmorceurSearch(pn); setShowAmorceurList(false); }
    setShowAmorceurScanner(false);
  }
  function handleScanParc(results) {
    if (!results?.length) return;
    const pn = (results[0].rawValue || "").trim();
    setParcMelangeEnCours(pn); setParcMelangeSearch(pn); setShowMelangeList(false); setShowParcScanner(false);
  }

  async function handleSubmit(e) {
    e.preventDefault(); setError(""); setSuccess("");
    handleCreateParcNumber();
    if (!solutionParcNumber) { setError("Merci de générer le Parc number."); return; }
    if (!pnResine)           { setError("Merci de choisir un PN Résine."); return; }
    if (!pnAmorceur)         { setError("Merci de choisir un PN Amorceur."); return; }
    if (!parcMelangeEnCours) { setError("Merci de sélectionner un PN de mélange en cours."); return; }
    const payload = {
      operator, entite, parcMelangeEnCours, pnResine, pnAmorceur,
      qtyResine: toFloat(qtyResine), qtyAmorceur: toFloat(qtyAmorceur),
      qtyMelangeFinal: toFloat(qtyMelangeFinal), temperature: toFloat(temperature),
      viscosite, extraitSec: toFloat(extraitSec), dureeRepos: Number(dureeRepos) || 0,
      solutionParcNumber, commentSolution, timestamp: new Date().toISOString(),
    };
    try {
      setSending(true);
      const res = await apiFetch("/api/production/rajout-amorceur-melange", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
      if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.message || "Erreur serveur"); }
      setQtyResine(""); setQtyAmorceur(""); setQtyMelangeFinal("");
      setTemperature(""); setViscosite(""); setExtraitSec(""); setDureeRepos(""); setCommentSolution("");
      setSuccess("✅ Données enregistrées avec succès.");
    } catch (err) { setError("❌ " + (err.message || "Erreur d'envoi.")); }
    finally { setSending(false); }
  }

  const timeStr = now.toLocaleTimeString("fr-FR");
  const dateStr = now.toLocaleDateString("fr-FR", { weekday: "short", day: "2-digit", month: "short", year: "numeric" });

  return (
    <div className="rma-page">
      <div className="rma-card">

        {/* HEADER */}
        <div className="rma-header">
          <span>Rajout de Mélange Liant &amp; Amorceur</span>
          <span className="rma-header-sub">Ajout sur mélange résine-amorceur en cours</span>
        </div>

        {/* NAV */}
        <div className="rma-nav">
          <button type="button" className="rma-btn-back" onClick={() => navigate("/menu")}>← Retour menu</button>
          <div className="rma-clock">
            <div className="rma-clock-time">{timeStr}</div>
            <div className="rma-clock-date">{dateStr}</div>
          </div>
        </div>

        {/* OPÉRATEUR */}
        <div className="rma-operator">
          <span className="rma-operator-dot" />
          {operator ? operator.toUpperCase() : "OPÉRATEUR NON CONNECTÉ"}
        </div>

        <form onSubmit={handleSubmit} className="rma-form">

          <div className="rma-section">
            <div className="rma-section-label">🏢 Entité qui prélève</div>
            <div className="rma-entite-row">
              {PRELEVEMENT_ENTITES.map((opt) => (
                <button
                  key={opt}
                  type="button"
                  className={`rma-entite-btn ${entite === opt ? "rma-entite-active" : ""}`}
                  onClick={() => setEntite(opt)}
                >
                  {opt}
                </button>
              ))}
            </div>
          </div>

          {/* MÉLANGE EN COURS */}
          <div className="rma-section rma-section-melange">
            <div className="rma-section-label rma-label-lime">🔄 Mélange en cours — Parc Number</div>
            <div ref={melangeBoxRef} style={{ position: "relative" }}>
              <div className="rma-select-row">
                <input value={parcMelangeSearch}
                  onChange={(e) => { setParcMelangeSearch(e.target.value); setShowMelangeList(true); }}
                  onFocus={() => setShowMelangeList(true)}
                  placeholder="Sélectionner le PN mélange en cours"
                  className="rma-select-input rma-select-input--lime" />
                <button type="button" className="rma-scan-btn" onClick={() => setShowParcScanner(true)} title="Scanner QR Mélange">📷</button>
              </div>
              {parcMelangeEnCours && (
                <div className="rma-selected-badge rma-badge-lime">
                  <span>✔</span><strong>{parcMelangeEnCours}</strong>
                  <button type="button" className="rma-clear-btn" onClick={() => { setParcMelangeEnCours(""); setParcMelangeSearch(""); }}>✕</button>
                </div>
              )}
              {showMelangeList && filteredMelange.length > 0 && (
                <div className="rma-dropdown" onMouseDown={(e) => e.preventDefault()}>
                  {filteredMelange.map((p) => (
                    <div key={p} className="rma-dropdown-item"
                      onClick={() => { setParcMelangeEnCours(p); setParcMelangeSearch(p); setShowMelangeList(false); }}>{p}</div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* RÉSINE + AMORCEUR */}
          <div className="rma-grid-2">

            {/* RÉSINE */}
            <div className="rma-section rma-section-resine">
              <div className="rma-section-label rma-label-resine">🧪 Liant (Résine)</div>
              <div className="rma-section-sublabel">Parc Number lot Liant</div>
              <div ref={resineBoxRef} style={{ position: "relative" }}>
                <div className="rma-select-row">
                  <input value={pnResineSearch}
                    onChange={(e) => { setPnResineSearch(e.target.value); setShowResineList(true); }}
                    onFocus={() => setShowResineList(true)}
                    placeholder="Sélectionner un PN"
                    className="rma-select-input" />
                  <button type="button" className="rma-scan-btn" onClick={() => setShowResineScanner(true)} title="Scanner QR Résine">📷</button>
                </div>
                {pnResine && (
                  <div className="rma-selected-badge">
                    <span>✔</span><strong>{pnResine}</strong>
                    <button type="button" className="rma-clear-btn" onClick={() => { setPnResine(""); setPnResineSearch(""); }}>✕</button>
                  </div>
                )}
                {showResineList && filteredResine.length > 0 && (
                  <div className="rma-dropdown" onMouseDown={(e) => e.preventDefault()}>
                    {filteredResine.map((p) => (
                      <div key={p} className="rma-dropdown-item"
                        onClick={() => { setPnResine(p); setPnResineSearch(p); setShowResineList(false); }}>{p}</div>
                    ))}
                  </div>
                )}
              </div>
              <div className="rma-field-sub">Quantité à prélever (kg)</div>
              <input type="text" inputMode="decimal" value={qtyResine}
                onChange={(e) => setQtyResine(e.target.value.replace(/[^0-9.,]/g, ""))}
                className="rma-num-input" placeholder="Ex: 20.5" />
            </div>

            {/* AMORCEUR */}
            <div className="rma-section rma-section-amorceur">
              <div className="rma-section-label rma-label-amorceur">🧴 Amorceur</div>
              <div className="rma-section-sublabel">Parc Number lot Mélange Amorceur</div>
              <div ref={amorceurBoxRef} style={{ position: "relative" }}>
                <div className="rma-select-row">
                  <input value={pnAmorceurSearch}
                    onChange={(e) => { setPnAmorceurSearch(e.target.value); setShowAmorceurList(true); }}
                    onFocus={() => setShowAmorceurList(true)}
                    placeholder="Sélectionner un PN"
                    className="rma-select-input" />
                  <button type="button" className="rma-scan-btn" onClick={() => setShowAmorceurScanner(true)} title="Scanner QR Amorceur">📷</button>
                </div>
                {pnAmorceur && (
                  <div className="rma-selected-badge">
                    <span>✔</span><strong>{pnAmorceur}</strong>
                    <button type="button" className="rma-clear-btn" onClick={() => { setPnAmorceur(""); setPnAmorceurSearch(""); }}>✕</button>
                  </div>
                )}
                {showAmorceurList && filteredAmorceur.length > 0 && (
                  <div className="rma-dropdown" onMouseDown={(e) => e.preventDefault()}>
                    {filteredAmorceur.map((p) => (
                      <div key={p} className="rma-dropdown-item"
                        onClick={() => { setPnAmorceur(p); setPnAmorceurSearch(p); setShowAmorceurList(false); }}>{p}</div>
                    ))}
                  </div>
                )}
              </div>
              <div className="rma-field-sub">Quantité à prélever (kg)</div>
              <input type="text" inputMode="decimal" value={qtyAmorceur}
                onChange={(e) => setQtyAmorceur(e.target.value.replace(/[^0-9.,]/g, ""))}
                className="rma-num-input" placeholder="Ex: 5.0" />
            </div>
          </div>

          {/* MÉLANGE FINAL */}
          <div className="rma-section rma-section-yellow">
            <div className="rma-section-label rma-label-yellow">⚖️ Quantité mélange finale (kg)</div>
            <input type="text" inputMode="decimal" value={qtyMelangeFinal}
              onChange={(e) => setQtyMelangeFinal(e.target.value.replace(/[^0-9.,]/g, ""))}
              className="rma-num-input rma-num-final" placeholder="Ex: 25.5" />
          </div>

          {/* PARAMÈTRES PROCESS — 4 colonnes */}
          <div className="rma-section">
            <div className="rma-section-label">⚙️ Paramètres process</div>
            <div className="rma-grid-4">
              <div className="rma-param-col">
                <div className="rma-param-label">Température (°C)</div>
                <input type="text" inputMode="decimal" value={temperature}
                  onChange={(e) => setTemperature(e.target.value.replace(/[^0-9.,]/g, ""))}
                  className="rma-num-input" placeholder="Ex: 22" />
              </div>
              <div className="rma-param-col">
                <div className="rma-param-label">Consistance / viscosité</div>
                <input type="text" value={viscosite}
                  onChange={(e) => setViscosite(e.target.value)}
                  className="rma-num-input" placeholder="Ex: 1200 cP" />
              </div>
              <div className="rma-param-col">
                <div className="rma-param-label">Extrait sec</div>
                <input type="text" inputMode="decimal" value={extraitSec}
                  onChange={(e) => setExtraitSec(e.target.value.replace(/[^0-9.,]/g, ""))}
                  className="rma-num-input" placeholder="Ex: 45.2" />
              </div>
              <div className="rma-param-col">
                <div className="rma-param-label">Durée de repos (min)</div>
                <input type="text" inputMode="numeric" value={dureeRepos}
                  onChange={(e) => setDureeRepos(e.target.value.replace(/[^0-9]/g, ""))}
                  className="rma-num-input" placeholder="Ex: 15" />
              </div>
            </div>
          </div>

          {/* PARC NUMBER SOLUTION */}
          <div className="rma-section rma-section-solution">
            <div className="rma-section-label rma-label-red">🏷 Parc Number Solution (versionné)</div>
            <div className="rma-solution-row">
              <button type="button" onClick={handleCreateParcNumber} className="rma-btn-create-pn">
                ⚡ Créer / Incrémenter Parc number
              </button>
              <button type="button" onClick={handlePrintSolution}
                disabled={!solutionParcNumber || printing}
                className="rma-btn-print-pn">
                {printing ? "⏳" : "🖨 Print"}
              </button>
            </div>
            <input value={solutionParcNumber} readOnly
              placeholder="Parc number versionné généré automatiquement…"
              className={`rma-pn-display ${solutionParcNumber ? "rma-pn-filled" : ""}`} />
            <div className="rma-field-sub rma-label-orange">💬 Commentaires / paramètres</div>
            <textarea rows={3} value={commentSolution}
              onChange={(e) => setCommentSolution(e.target.value)}
              className="rma-textarea"
              placeholder="Observations, paramètres complémentaires…" />
          </div>

          {/* MESSAGES */}
          {error   && <div className="rma-msg rma-msg-error">{error}</div>}
          {success && <div className="rma-msg rma-msg-success">{success}</div>}

          {/* SUBMIT */}
          <div className="rma-submit-row">
            <button type="submit" disabled={sending} className="rma-btn-submit">
              {sending ? "⏳ Envoi en cours…" : "✔ OK confirmation et envoi"}
            </button>
            <button type="button" className="rma-btn-time">
              Time
              <div className="rma-btn-time-sub">{timeStr}</div>
            </button>
          </div>

        </form>
      </div>

      {/* SCANNERS */}
      {[
        { show: showResineScanner,   onClose: () => setShowResineScanner(false),   onScan: handleScanResine,   title: "📷 Scanner PN Résine (Liant)" },
        { show: showAmorceurScanner, onClose: () => setShowAmorceurScanner(false), onScan: handleScanAmorceur, title: "📷 Scanner PN Amorceur" },
        { show: showParcScanner,     onClose: () => setShowParcScanner(false),     onScan: handleScanParc,     title: "📷 Scanner Parc Mélange en cours" },
      ].map(({ show, onClose, onScan, title }) =>
        show ? (
          <div key={title} className="rma-modal-backdrop" onClick={onClose}>
            <div className="rma-modal-scanner" onClick={(e) => e.stopPropagation()}>
              <div className="rma-modal-title">{title}</div>
              <div style={{ borderRadius: 10, overflow: "hidden" }}>
                <Scanner onScan={onScan} onError={console.error} constraints={{ facingMode: "environment" }} />
              </div>
              <button type="button" className="rma-btn-close-scanner" onClick={onClose}>✕ Fermer</button>
            </div>
          </div>
        ) : null
      )}

      <Style />
    </div>
  );
}

/* ── STYLES ── */
function Style() {
  return (
    <style>{`
      *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

      .rma-page {
        min-height: 100vh; width: 100%;
        background: radial-gradient(ellipse at top,#01283a 0%,#010F14 70%);
        display: flex; justify-content: center; align-items: flex-start;
        padding: 16px; font-family: 'Inter','Segoe UI',sans-serif;
      }
      .rma-card {
        width: 100%; max-width: 720px;
        background: #011e2b; border: 1px solid #1a4a5a;
        border-radius: 16px; overflow: hidden;
        box-shadow: 0 8px 40px rgba(0,0,0,0.6), 0 0 0 1px #0a3040;
      }

      /* HEADER */
      .rma-header {
        background: linear-gradient(135deg,#E6FF3E,#c8e800);
        color: #000; padding: 14px 20px;
        display: flex; flex-direction: column; align-items: center; gap: 2px;
      }
      .rma-header span  { font-size: 14px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.08em; text-align: center; }
      .rma-header-sub   { font-size: 11px; font-weight: 500; opacity: 0.6; }

      /* NAV */
      .rma-nav {
        background: #010f14; padding: 8px 16px;
        display: flex; justify-content: space-between; align-items: center;
        border-bottom: 1px solid #1a4a5a;
      }
      .rma-btn-back {
        background: transparent; color: #7ab8cc; border: 1px solid #1a4a5a;
        border-radius: 6px; padding: 5px 10px; font-size: 11px; font-weight: 600; cursor: pointer; transition: all 0.2s;
      }
      .rma-btn-back:hover { background: #1a4a5a; color: #fff; }
      .rma-clock          { text-align: right; }
      .rma-clock-time     { color: #E6FF3E; font-size: 15px; font-weight: 700; font-variant-numeric: tabular-nums; }
      .rma-clock-date     { color: #5a8a99; font-size: 10px; }

      /* OPÉRATEUR */
      .rma-operator {
        display: flex; align-items: center; gap: 10px;
        background: linear-gradient(90deg,#012836,#013d50);
        border: 1px solid #1a5a6a; border-radius: 10px;
        margin: 14px 20px 0; padding: 12px 16px;
        color: #fff; font-size: 14px; font-weight: 700; letter-spacing: 0.06em;
      }
      .rma-operator-dot { width: 10px; height: 10px; background: #00B050; border-radius: 50%; box-shadow: 0 0 6px #00B050; flex-shrink: 0; }

      /* FORM */
      .rma-form { padding: 16px 20px 24px; display: flex; flex-direction: column; gap: 14px; overflow-y: auto; flex: 1; }

      /* SECTIONS */
      .rma-section {
        background: #012030; border: 1px solid #1a4a5a;
        border-radius: 12px; padding: 14px 16px;
        display: flex; flex-direction: column; gap: 10px;
      }
      .rma-section-melange  { border-color: #E6FF3E; background: #141a00; }
      .rma-section-resine   { border-color: #00702F; background: #001a10; }
      .rma-section-amorceur { border-color: #8B0000; background: #1a0810; }
      .rma-section-yellow   { border-color: #FFD966; background: #1a1400; align-items: center; }
      .rma-section-solution { border-color: #C00000; background: #1a0808; }
      .rma-section-label    { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #7ab8cc; }
      .rma-entite-row { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; }
      .rma-entite-btn {
        background: #012030; color: #7ab8cc; border: 1px solid #1a4a5a;
        border-radius: 8px; padding: 10px 8px; font-size: 13px; font-weight: 700;
        cursor: pointer; transition: all 0.15s;
      }
      .rma-entite-btn:hover { background: #1a4a5a; color: #fff; }
      .rma-entite-active { background: #E6FF3E; color: #000; border-color: #E6FF3E; }
      .rma-section-sublabel { font-size: 11px; color: #7ab8cc; font-weight: 600; }
      .rma-label-lime       { color: #E6FF3E; }
      .rma-label-resine     { color: #7aff9a; }
      .rma-label-amorceur   { color: #E5A5D5; }
      .rma-label-yellow     { color: #FFD966; }
      .rma-label-red        { color: #ff9090; }
      .rma-label-orange     { color: #FFB366; }
      .rma-field-sub        { font-size: 11px; font-weight: 600; color: #7ab8cc; }

      /* GRIDS */
      .rma-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
      .rma-grid-4 { display: grid; grid-template-columns: repeat(4,1fr); gap: 10px; }

      /* SELECT ROW */
      .rma-select-row   { display: flex; gap: 8px; align-items: center; }
      .rma-select-input {
        flex: 1; background: #003818; color: #7aff9a;
        border: 1px solid #005020; border-radius: 8px;
        padding: 9px 12px; font-size: 13px; font-weight: 600;
        outline: none; transition: border 0.2s;
      }
      .rma-select-input--lime { background: #141a00; color: #E6FF3E; border-color: #3a5000; }
      .rma-select-input--lime:focus { border-color: #E6FF3E; }
      .rma-select-input:focus { border-color: #00B050; box-shadow: 0 0 0 2px rgba(0,176,80,0.15); }
      .rma-scan-btn {
        width: 40px; height: 40px; flex-shrink: 0; background: #012030;
        border: 1px solid #1a4a5a; border-radius: 8px;
        font-size: 18px; cursor: pointer; transition: background 0.2s;
      }
      .rma-scan-btn:hover { background: #1a4a5a; }
      .rma-selected-badge {
        display: flex; align-items: center; gap: 8px; margin-top: 6px;
        background: #002810; border: 1px solid #00B050; border-radius: 8px;
        padding: 5px 10px; font-size: 11px; color: #7aff9a;
      }
      .rma-badge-lime { background: #141a00; border-color: #E6FF3E; color: #E6FF3E; }
      .rma-selected-badge strong { flex: 1; font-size: 12px; word-break: break-all; }
      .rma-clear-btn { background: transparent; border: none; color: #ff8080; cursor: pointer; font-size: 14px; font-weight: 700; }
      .rma-dropdown {
        position: absolute; left: 0; right: 0; margin-top: 4px;
        max-height: 180px; overflow-y: auto;
        background: #002818; border: 1px solid #005020; border-radius: 8px; z-index: 50;
        box-shadow: 0 8px 24px rgba(0,0,0,0.5);
      }
      .rma-dropdown-item {
        padding: 7px 12px; color: #aaffcc; font-size: 12px;
        cursor: pointer; border-bottom: 1px solid #003818; transition: background 0.15s;
      }
      .rma-dropdown-item:hover { background: #003d20; }

      /* NUM INPUTS */
      .rma-num-input {
        width: 100%; background: #010f14; color: #fff;
        border: 1px solid #1a4a5a; border-radius: 8px;
        padding: 10px 12px; font-size: 16px; font-weight: 700; text-align: center;
        outline: none; transition: border 0.2s;
      }
      .rma-num-input:focus { border-color: #E6FF3E; box-shadow: 0 0 0 2px rgba(230,255,62,0.1); }
      .rma-num-final { font-size: 24px; max-width: 280px; background: #FFF2CC; color: #000; border-color: #FFD966; border-width: 2px; }
      .rma-num-final:focus { border-color: #C00000; }

      /* PARAMS */
      .rma-param-col   { display: flex; flex-direction: column; gap: 6px; }
      .rma-param-label {
        background: #F2F2F2; color: #000; border: 2px solid #C00000;
        border-radius: 8px; padding: 5px 4px; text-align: center; font-weight: 700; font-size: 10px;
      }

      /* SOLUTION */
      .rma-solution-row  { display: flex; gap: 8px; align-items: center; }
      .rma-btn-create-pn {
        flex: 1; background: #C00000; color: #fff; border: 2px solid #800000;
        border-radius: 8px; padding: 10px 12px; font-weight: 700; font-size: 12px;
        cursor: pointer; transition: opacity 0.2s; text-align: center;
      }
      .rma-btn-create-pn:hover { opacity: 0.85; }
      .rma-btn-print-pn {
        background: #FFD966; color: #000; border: 2px solid #C00000;
        border-radius: 8px; padding: 10px 16px; font-weight: 800; font-size: 13px;
        cursor: pointer; transition: opacity 0.2s; white-space: nowrap;
      }
      .rma-btn-print-pn:disabled { opacity: 0.5; cursor: not-allowed; }
      .rma-btn-print-pn:hover:not(:disabled) { opacity: 0.85; }
      .rma-pn-display {
        width: 100%; background: #1a2a2a; color: #7ab8cc;
        border: 1px dashed #3a6a7a; border-radius: 8px;
        padding: 10px 14px; font-size: 11px; font-family: monospace;
        cursor: not-allowed; outline: none; letter-spacing: 0.03em; word-break: break-all;
      }
      .rma-pn-filled { background: #012836; color: #7aff9a; border-color: #00B050; border-style: solid; }
      .rma-textarea {
        width: 100%; background: #EAC1A8; color: #000;
        border: 2px solid #C00000; border-radius: 8px;
        padding: 10px 12px; font-size: 13px; resize: vertical; outline: none; line-height: 1.5;
        transition: border 0.2s;
      }
      .rma-textarea:focus { border-color: #900000; }

      /* MESSAGES */
      .rma-msg         { border-radius: 8px; padding: 10px 14px; font-size: 13px; font-weight: 600; }
      .rma-msg-error   { background: #2a0808; border: 1px solid #C00000; color: #ff9090; }
      .rma-msg-success { background: #002810; border: 1px solid #00B050; color: #80ff90; }

      /* SUBMIT */
      .rma-submit-row  { display: flex; gap: 10px; align-items: center; }
      .rma-btn-submit  {
        flex: 1; background: linear-gradient(135deg,#00B050,#008a3c);
        color: #000; border: none; border-radius: 10px;
        padding: 14px; font-size: 15px; font-weight: 800;
        text-transform: uppercase; letter-spacing: 0.08em; cursor: pointer;
        transition: opacity 0.2s, transform 0.1s;
        box-shadow: 0 4px 16px rgba(0,176,80,0.3);
      }
      .rma-btn-submit:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
      .rma-btn-submit:disabled { opacity: 0.5; cursor: not-allowed; }
      .rma-btn-time {
        min-width: 110px; background: #C00000; color: #fff;
        border: 2px solid #7F0000; border-radius: 8px;
        padding: 8px 10px; font-weight: 700; font-size: 12px; cursor: default; text-align: center;
      }
      .rma-btn-time-sub { font-size: 11px; margin-top: 2px; font-variant-numeric: tabular-nums; }

      /* SCANNER MODAL */
      .rma-modal-backdrop {
        position: fixed; inset: 0; background: rgba(0,0,0,0.8);
        display: flex; justify-content: center; align-items: center;
        z-index: 9999; backdrop-filter: blur(4px);
      }
      .rma-modal-scanner {
        width: 90%; max-width: 420px; background: #011e2b;
        border: 1px solid #E6FF3E; border-radius: 14px; padding: 16px;
        display: flex; flex-direction: column; gap: 12px;
        box-shadow: 0 0 40px rgba(230,255,62,0.15);
      }
      .rma-modal-title { color: #E6FF3E; font-size: 14px; font-weight: 700; text-align: center; }
      .rma-btn-close-scanner {
        background: #C00000; color: #fff; border: none; border-radius: 8px;
        padding: 10px; font-weight: 700; font-size: 13px; cursor: pointer; transition: opacity 0.2s;
      }
      .rma-btn-close-scanner:hover { opacity: 0.85; }

      /* TABLETTE */
      @media (min-width: 768px) {
        .rma-card  { max-width: 860px; }
        .rma-header span { font-size: 17px; }
        .rma-form  { padding: 20px 28px 28px; gap: 18px; }
        .rma-select-input { font-size: 15px; padding: 11px 14px; }
        .rma-scan-btn     { width: 48px; height: 48px; font-size: 22px; }
        .rma-num-input    { font-size: 20px; padding: 12px; }
        .rma-num-final    { font-size: 28px; max-width: 340px; }
        .rma-param-label  { font-size: 11px; padding: 6px; }
        .rma-btn-submit   { font-size: 16px; padding: 16px; }
      }

      /* DESKTOP */
      @media (min-width: 1024px) {
        .rma-card  { max-width: 1060px; }
        .rma-header span { font-size: 20px; }
        .rma-form  { padding: 20px 36px 36px; gap: 20px; }
        .rma-operator { margin: 16px 36px 0; font-size: 16px; }
        .rma-section  { padding: 18px 20px; border-radius: 14px; }
        .rma-section-label { font-size: 13px; }
        .rma-select-input  { font-size: 17px; padding: 12px 16px; }
        .rma-scan-btn      { width: 54px; height: 54px; font-size: 24px; }
        .rma-num-input     { font-size: 22px; padding: 14px; }
        .rma-num-final     { font-size: 32px; max-width: 400px; }
        .rma-param-label   { font-size: 12px; padding: 8px; }
        .rma-btn-create-pn { font-size: 14px; padding: 12px 16px; }
        .rma-btn-print-pn  { font-size: 14px; padding: 12px 20px; }
        .rma-pn-display    { font-size: 13px; padding: 12px 16px; }
        .rma-textarea      { font-size: 14px; padding: 12px 16px; }
        .rma-btn-submit    { font-size: 18px; padding: 18px; border-radius: 12px; }
        .rma-btn-time      { min-width: 140px; }
      }

      /* XXL */
      @media (min-width: 1400px) {
        .rma-page  { padding: 32px; }
        .rma-card  { max-width: 1320px; border-radius: 20px; }
        .rma-header { padding: 24px 48px; }
        .rma-header span { font-size: 24px; letter-spacing: 0.12em; }
        .rma-header-sub  { font-size: 14px; }
        .rma-nav   { padding: 14px 36px; }
        .rma-clock-time  { font-size: 22px; }
        .rma-operator    { margin: 18px 48px 0; font-size: 20px; padding: 16px 24px; border-radius: 14px; }
        .rma-operator-dot { width: 14px; height: 14px; }
        .rma-form  { padding: 24px 48px 40px; gap: 24px; }
        .rma-section { padding: 22px 24px; border-radius: 16px; }
        .rma-section-label  { font-size: 15px; letter-spacing: 0.1em; }
        .rma-section-sublabel { font-size: 13px; }
        .rma-grid-2        { gap: 18px; }
        .rma-grid-4        { gap: 14px; }
        .rma-select-input  { font-size: 20px; padding: 14px 18px; border-radius: 10px; }
        .rma-scan-btn      { width: 62px; height: 62px; font-size: 26px; border-radius: 10px; }
        .rma-dropdown-item { font-size: 14px; padding: 10px 16px; }
        .rma-num-input     { font-size: 26px; padding: 16px; border-radius: 10px; }
        .rma-num-final     { font-size: 38px; max-width: 480px; padding: 18px; border-radius: 12px; }
        .rma-param-label   { font-size: 13px; padding: 10px; border-radius: 10px; }
        .rma-solution-row  { gap: 12px; }
        .rma-btn-create-pn { font-size: 16px; padding: 14px 20px; border-radius: 10px; }
        .rma-btn-print-pn  { font-size: 16px; padding: 14px 24px; border-radius: 10px; }
        .rma-pn-display    { font-size: 14px; padding: 14px 18px; border-radius: 10px; }
        .rma-textarea      { font-size: 16px; padding: 14px 18px; border-radius: 10px; }
        .rma-msg           { font-size: 15px; padding: 14px 18px; border-radius: 10px; }
        .rma-btn-submit    { font-size: 22px; padding: 22px; border-radius: 14px; letter-spacing: 0.1em; }
        .rma-btn-time      { min-width: 170px; font-size: 14px; padding: 14px; border-radius: 10px; }
        .rma-btn-time-sub  { font-size: 13px; }
      }
    `}</style>
  );
}
